export default [
  {
    code: 'plugId',
    name: 'plugGuid',
    type: 'select',
    isUuid: true,
    dictionary: 'devices',
    itemValue: 'serial',
    itemText: 'serial',
  },
  {
    code: 'sigfoxId',
    name: 'sigfoxId',
    type: 'input',
  },
  {
    code: 'zigbeeId',
    name: 'zigbeeId',
    type: 'input',
  },
  {
    code: 'firmwareVersion',
    name: 'plug_version',
    type: 'input',
  },
]
